var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 40,
    viewBox: "0 0 20 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6979 21.6665L14.4271 16.8748H9.79167V13.7498C9.79167 12.3957 10.4167 11.1457 12.5 11.1457H14.6354V7.03109C14.6354 7.03109 12.7083 6.6665 10.8854 6.6665C7.08333 6.6665 4.58333 9.01025 4.58333 13.1769V16.8748H0.3125V21.6665H4.58333V33.3332H9.79167V21.6665H13.6979Z",
    fill: "#2F2F37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookBlack);
export default __webpack_public_path__ + "static/media/facebookBlack.569ad6a4a2ceeb7bdb39a276cc16451f.svg";
export { ForwardRef as ReactComponent };